import { Component, Inject, OnInit } from '@angular/core'
import { AuthService } from '../../core/services/auth/auth.service'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { ServiceTypeCreateComponent } from '../../features/service/service-type-create/service-type-create.component'
import { ServiceTypeService } from '../../core/services/service/service-type/service-type.service'
import { ServiceTypeEditComponent } from '../../features/service/service-type-edit/service-type-edit.component'
import { FormSearchComponent } from '../../shared/components/form-search/form-search.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'
import { ServiceOrderCreate } from '../../features/service/service-order/service-order-create/service-order-create.component'
import { ContractCreateComponent } from '../../features/contract/contract-create/contract-create.component'
import { ResponseRequestModel } from '../../core/models/response.model'
import { downloadBase64File } from '../../shared/utils/download_base64'
import { convertCurrency } from '../../shared/utils/utils'
import { ProposalClientCreateComponent } from '../../features/proposal/proposal-client-create/proposal-client-create.component'
import { ProposalClientEditComponent } from '../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { ProposalClientService } from '../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../core/services/contract/contract-client/contract-client.service'
import { ScheduleFleetService } from '../../core/services/schedule/schedule-fleet/schedule-fleet.service'
import { ScheduleComponent } from '../../features/schedule/schedule.component'
import { MonitoringSearchComponent } from "./monitoring-search/monitoring-search.component";
import { FormGroup } from '@angular/forms'
import { TableListFixedComponent } from "../../shared/components/table-list-fixed/table-list-fixed.component";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { OccurrencesModalCreateComponent } from '../../features/occurrence/occurrences-modal-create/occurrences-modal-create.component'
import { TableListMonitoringComponent } from "../../shared/components/table-list-monitoring/table-list-monitoring.component"
import { OccurrencesModalTableComponent } from '../../features/occurrence/occurrences-modal-table/occurrences-modal-table.component'

@Component({
  selector: 'monitoring-component',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MonitoringSearchComponent,
    TableListFixedComponent,
    MatPaginatorModule,
    TableListMonitoringComponent
  ],
  templateUrl: './monitoring.component.html',
  styleUrl: './monitoring.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class MonitoringComponent implements OnInit {

  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private scheduleFleetService: ScheduleFleetService,
    private authService: AuthService,
    private dialog: MatDialog,

  ) { }

  form!: FormGroup;
  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'os_period',
      key: 'os_period',
      description: 'Periodo',
    },
    {
      keyColumn: 'os_code',
      key: 'os_code',
      description: 'Códigos',
    },
    {
      keyColumn: 'nomeCliente',
      key: 'nomeCliente',
      description: 'Cliente',
    },
    {
      keyColumn: 'os_percusent',
      key: 'os_percusent',
      description: 'Percurso',
    },
    {
      keyColumn: 'os_services',
      key: 'os_services',
      description: 'Serviços',
    },
    {
      keyColumn: 'os_vehicles',
      key: 'os_vehicles',
      description: 'Veículo',
    },
    {
      keyColumn: 'os_driver',
      key: 'os_driver',
      description: 'Motorista',
    },
    {
      keyColumn: 'nomeEvento',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'status',
      key: 'descricaoStatus',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, occurrence: true, view: true },
      description: 'Ações',
      stickerEnd: true,
      width: '100px'
    },
  ]

  screen: string = 'status cotação'

  ngOnInit() {
    this.checkColumnAction()
    this.loading = true
    // this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        occurrence: true,
        view: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.searchFleet(event)
  //   }
  // }

  addOccurrenceItem(item: any) {
    const dialogRef = this.dialog.open(OccurrencesModalTableComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    // dialogRef.componentInstance.responseEdit.subscribe((response) => {
    //   if (response) {
    //     this.uploadList()
    //   }
    // })
  }

  pageChanged(page: number) {
    this.page = page
    // this.uploadList()
  }

  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     this.searchFleet(type)
  //   }
  // }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    const item = this.createModel()
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.searchFleet(item)
    }
  }

  listSearch(event: any) {
    this.loading = true
    if (event == null) {
      this.loading = false
      this.itemsList = []
      this.numberRows = 0
      this.loading = false

    } else if (event === 'reset') {
      const item = this.createModel()
      this.searchFleet(item)

    } else if (event && event !== 'reset') {
      this.searchFleet(event)
    } else {

      this.itemsList = event
      this.numberRows = event.length
      this.loading = false
    }
    //time para aguardar o retorno da api

  }



  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        // Verifica se o status da proposta é 'Pendente'


        list.push({
          ...item,
          valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        })

        // if (item.statusPropostaDescricao === 'Pendente'){

        //   list.push({
        //     ...item,
        //     valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        //   })
        // }
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  createModel() {


    return {

      dataInicio: '',
      dataFinal: '',
      nomeCliente: '',
      nomeSubCliente: '',
      status: 0,
      descricaoOrigem: '',
      descricaoDestino: '',
      descricaoTipoServico: '',
      servico: '',
      descricaoTipoVeiculo: '',
      descricaoTipoMotorista: '',
      codigoTg: '',
      codigoOs: '',
    }
  }

  searchFleet(item: any) {
    this.loading = true;
    this.scheduleFleetService.searchPagedMonitoring(this.page, this.rows, item).subscribe({
      next: (res) => {
        this.treatResponse(res)
        this.loading = false
      },
      error: (err) => {
        console.log(err)
        this.loading = false
      }
    })
    // this.scheduleDriverService.createAgendaMotorista(item).subscribe({
    //   next: (res) => {
    //     this.snackbar.success('Agendamento do motorista criado com sucesso')
    //     this.loading = false
    //     this.resetForm()
    //   },
    //   error: (err) => {
    //     console.error('Ocorreu um erro ao adicionar o agendamento do motorista', err)
    //     this.loading = false
    //   }
    // });
  }


  searchListItems() {
    this.loading = true
    this.scheduleFleetService
      .listPagedAgendaFrota(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }



  viewItem(item: any) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, viewMode: true }


    })
    // dialogRef.componentInstance.responseViewEdit.subscribe((response: any) => {
    //   if (response) {
    //     this.searchFleet()
    //   }
    // })
    // dialogRef.afterClosed().subscribe(() => {
    //   this.searchFleet()
    // })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       console.log('res', response)
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {
    console.log('item delete', item)
  }

}
